<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-card
          :bordered="false"
          class="header-solid h-full"
          :bodyStyle="{ padding: 0 }"
        >
          <template #title>
            <a-row type="flex" align="middle">
              <a-col :span="24" :md="12">
                <h5 class="font-semibold m-0">جدول سطوح دسترسی</h5>
              </a-col>
              <a-col
                :span="24"
                :md="12"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <a-button
                  class="btn-outline-purple"
                  icon="search"
                  @click="isHidden = !isHidden"
                >
                  جستجو
                </a-button>
                &nbsp;

                <a-button v-show="$root.hasPermission('/roles/add/')"
                  href="/roles/add"
                  class="btn-outline-blue"
                  icon="plus"
                >
                  افزودن سطح
                </a-button>
                
              </a-col>
            </a-row>
          </template>

          <b-card
            style="margin:20px; !important ; border:none;"
            v-if="isHidden"
          >
               <a-col style="margin-top: 20px" :md="4">
                <a-button
                  class="btn-outline-green w-100"
                  icon="search"
                  @click="getData"
                >
                  جستجو
                </a-button>
                
              </a-col>
              <a-col :md="20">
                <label class="sr-only" for="inline-form-input-name">نام</label>
                <b-form-input
                  v-model="search.name"
                  id="inline-form-input-name"
                  class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-input>
              </a-col>
            
             
          </b-card>
          <a-row
            style="justify-content: center; display: flex"
            v-if="$store.state.loading"
          >
            <template>
              <div>
                <a-spin />
              </div>
            </template>
          </a-row>
          <div v-else>
            <section class="w-100 p-4 text-center">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">شناسه</th>
                    <th scope="col">نام</th>
             
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in data">
                    <th scope="row">#{{ row.id }}</th>
                   
                    <td>
                      <b-badge
                        variant="light"
                        class="bg-secondary"
                        >{{  row.name }}</b-badge
                      >
                     
                    </td>

                  
                   
                    <td>
                      <a-button v-show="$root.hasPermission('/roles/edit/')"
                        class="btn-outline-warning"
                        shape="square"
                        icon="edit"
                        type="link"
                        :href="'/roles/edit/'+row.id"
                      />

                      &nbsp;
                      <!-- <a-button v-show="$root.hasPermission('/roles/delete/')"
                        class="btn-outline-danger"
                        shape="square"
                        icon="delete"
                        @click="deleteRow(`roles/delete/${row.id}`)"
                      ></a-button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
            <a-row class="pagination">
              <a-pagination
                :total="total"
                :item-render="$root.itemRender"
                @change="getData(currentPage)"
                v-model="currentPage"
              />
            </a-row>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      currentPage: 1,
      total: 0,
      isHidden: false,
      search: {
        name: "",
       
      },
    };
  },
  methods: {
    async getData() {
      let _this = this;
      this.$store.state.loading = true;
      let url = `/roles?page=${this.currentPage}&&name=${this.search.name}`;
      await axios
        .get(url)
        .then(function (response) {
          _this.data = response.data.data;
          _this.$store.state.loading = false;
          _this.total = response.data.total;
          _this.currentPage = response.data.current_page;
        })
        .catch(function (err) {
          _this.$root.handleAxiosError(err);
        });
    },
    clear() {
      this.search = {
        name: "",
      
      };
      this.getData();
    },
    deleteRow(url) {
      this.$swal({
        title: " با حذف سطح دسترسی همه کاربران مربوط به آن حذف می شوند .  آیا از حذف اطلاعات اطمینان دارید؟",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "بله",
        denyButtonText: "لغو",
      }).then((result) => {
        if (result.isConfirmed) {
          let _this = this;
          axios
            .get(url)
            .then(function (response) {
              _this.$toast.success("با موفقیت حذف شد.");
              _this.getData();
            })
            .catch(function (err) {
              _this.$root.handleAxiosError(err);
            });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scope>
.pagination {
  display: flex;
  justify-content: center;
  margin: 15px;
}
</style>
